import { useCallback } from 'react';
import { useHoneybookAI } from './honeybook-ai-provider';
import { ActionType, ActionSubscription } from '../ai-core';

/**
 * Hook to access and interact with the ActionManager
 *
 * @returns Object with methods to subscribe to actions
 */
export const useAIActions = () => {
    const ai = useHoneybookAI();
    const actionManager = ai.getActionManager();

    /**
     * Subscribe to actions, optionally filtered by feature and action types
     *
     * @param subscription - Configuration for the action subscription
     * @returns Unsubscribe function
     */
    const subscribe = useCallback(
        <T extends ActionType[] = ActionType[]>(
            subscription: ActionSubscription<T>
        ) => {
            return actionManager.subscribe(subscription);
        },
        [actionManager]
    );

    return {
        subscribe
    };
};

export default useAIActions;
